const Overlay = ({ opacity }) => (
    <div className={`absolute top-0 left-0 w-full h-full bg-black transition-all duration-500 ease-linear
      ${opacity ? `${opacity}` : 'bg-opacity-70'}`}
    />

  );

export default Overlay;